<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-container
      class="px-0"
    >
      <v-row
        style="border-bottom: 1px solid #818181;width: 100%;z-index: 20"
        class="mx-0 mt-0 pb-1 mb-0"
      >
        <v-col
          cols="12"
          class="pa-0 px-1 mb-1 d-flex"
        >
          <v-text-field
            ref="searchRef"
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('search')"
            solo
            flat
            height="45"
            :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"
            dense
            hide-details
            clearable
            :loading="loading"
          />
          <v-btn
            icon
            @click="getItems"
          >
            <v-icon
              color="primary"
              style="font-size: 26px;margin-top: 2px"
            >
              mdi-refresh
            </v-icon>
          </v-btn>
          <v-btn
            icon
            @click="filter = true"
          >
            <v-icon
              color="primary"
              style="font-size: 26px;margin-top: 2px"
            >
              mdi-filter-outline
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row
        class="mx-0"
      >
        <v-col
          cols="12"
          class="d-flex pt-0 px-0"
        >
          <v-item-group
            mandatory
            class="mt-1 mx-0"
            style="width: 100%"
          >
            <v-row
              class="mx-0"
              style="overflow-y: scroll;overflow-x: hidden;border-bottom: 0px solid #e3e3e3;height: calc(100vh - 132px)"
            >
              <v-col
                v-for="(item, i) in items"
                :key="i"
                cols="12"
                class="pa-0 px-1 mb-1"
              >
                <v-card
                  flat
                  width="100%"
                  class="d-flex my-0 px-0 pa-2"
                >
                  <v-col
                    class="pa-0"
                    style="max-width: 44px;"
                  >
                    <v-menu
                      offset-y
                    >
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn
                          color="primary"
                          v-bind="attrs"
                          icon
                          v-on="on"
                        >
                          <v-icon
                            medium
                          >
                            mdi-dots-vertical
                          </v-icon>
                        </v-btn>
                      </template>
                      <v-list dense>
                        <v-list-item
                          v-show="item.store"
                          link
                          @click="storeInServer(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-clipboard-edit</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('sendToServer')" />
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-col>
                  <v-col
                    class="pa-0"
                  >
                    <div
                      class="pe-2"
                      style="font-size: 16px;line-height: 1.5;"
                    >
                      {{ $t('customer') }} : {{ item.account.name }}
                    </div>
                    <div
                      class="pe-2"
                      style="font-size: 14px;line-height: 1.5;color: #818181"
                    >
                      {{ $t('number') }} : {{ item.number }}
                    </div>
                    <div
                      class="pe-2"
                      style="font-size: 14px;line-height: 1.5;color: #818181"
                    >
                      {{ $t('date') }} : {{ item.date }}
                    </div>
                    <div
                      class="pe-2"
                      style="font-size: 14px;line-height: 1.5;color: #818181"
                    >
                      {{ $t('address') }} : {{ item.account.address }}
                    </div>
                    <div
                      class="pe-2"
                      style="font-size: 14px;line-height: 1.5;color: #818181"
                    >
                      {{ $t('mobile') }} : {{ item.account.mobile }}
                    </div>
                    <div
                      class="pe-2"
                      style="font-size: 16px;line-height: 1.5;color: #0066FF"
                    >
                      {{ (item.store ? $t('serverNotStore') : $t('serverStored')) }}
                    </div>
                  </v-col>
                  <v-col
                    class="pa-0"
                  >
                    <div
                      class="pe-2 text-left"
                      style="font-size: 16px;line-height: 1.5;"
                    >
                      <strong style="color: #00c853">{{ $numberFormat(item.sumAmount) }}</strong> {{ $store.state.currency.name }}
                    </div>
                  </v-col>
                </v-card>
                <v-divider />
              </v-col>
              <v-col
                v-if="lastPage > 1 && lastPage > page"
                class="d-flex pa-1 text-center"
                cols="12"
              >
                <v-spacer />
                <div
                  v-observe-visibility="{
                    callback: visibilityChanged
                  }"
                  width="100%"
                  height="40px"
                  align="center"
                  class="d-flex my-0 pa-2 text-center"
                >
                  <v-progress-circular
                    :size="20"
                    :width="2"
                    color="primary"
                    indeterminate
                  />
                </div>
                <v-spacer />
              </v-col>
            </v-row>
          </v-item-group>
        </v-col>
        <div style="position: fixed;bottom: 30px;left: 30px">
          <v-fab-transition>
            <v-btn
              color="primary"
              dark
              fab
              @click="goTo((type == 'sell' ? 'mSell' : 'mReturnSell'))"
            >
              <v-icon style="font-size: 32px">
                mdi-plus
              </v-icon>
            </v-btn>
          </v-fab-transition>
        </div>
      </v-row>
    </v-container>
    <v-dialog
      v-model="filter"
      width="95%"
      :draggable="true"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="filter = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('filter') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col
            cols="12"
            md="4"
          >
            <m-autocomplete
              v-model="account"
              :title="(type == 'purchase' || type == 'returnPurchase' ? $t('detail') : $t('customer'))"
              type="person"
              :filter="true"
              :offline="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
            class="mb-4"
          >
            <v-text-field
              v-model="fromNumber"
              :label="$t('from') + ' ' + $t('number')"
              outlined
              height="40"
              dense
              clearable
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
            class="mb-4"
          >
            <v-text-field
              v-model="toNumber"
              :label="$t('until') + ' ' + $t('number')"
              outlined
              height="40"
              dense
              clearable
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
            class="mb-4"
          >
            <money
              v-model="fromAmount"
              :dense="true"
              :label="$t('from') + ' ' + $t('amount')"
              :outlined="true"
              :solo="false"
              height="40"
              :clearable="true"
              value-when-is-empty=""
              :options="options"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
            class="mb-4"
          >
            <money
              v-model="toAmount"
              :dense="true"
              :label="$t('until') + ' ' + $t('amount')"
              :outlined="true"
              :solo="false"
              height="40"
              :clearable="true"
              value-when-is-empty=""
              :options="options"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
            class="mb-4"
          >
            <template>
              <v-text-field
                id="fromId"
                v-model="fromDate"
                :label="$t('from') + ' ' + $t('date')"
                outlined
                height="40"
                dense
                clearable
              />
              <date-picker
                v-model="fromDate"
                element="fromId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col
            cols="12"
            md="4"
            class="mb-4"
          >
            <template>
              <v-text-field
                id="toId"
                v-model="toDate"
                :label="$t('until') + ' ' + $t('date')"
                outlined
                height="40"
                dense
                clearable
              />
              <date-picker
                v-model="toDate"
                element="toId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                :min="fromDate"
                auto-submit
                :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                @close="setDate"
              />
            </template>
          </v-col>
        </v-row>
        <v-card-actions class="px-3">
          <v-row class="ma-0">
            <v-col
              cols="6"
              class="pa-0 py-1"
            >
              <v-btn
                class=" mx-0"
                color="primary"
                @click="getItems"
              >
                {{ $t('filter') }}
              </v-btn>
            </v-col>
            <v-col
              cols="6"
              class="pa-0 py-1"
            >
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="filter = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : '')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
  import General from '../../../../Mixins/general'
  export default {
    name: 'InvoiceList',
    components: {
    },
    mixins: [General],
    props: ['input', 'refId', 'typeProp', 'accountProp'],
    data: () => ({
      selected: [],
      lastPage: 1,
      removedInvoices: null,
      groupPrintDialog: false,
      invoicePrintDialog: false,
      printDialog: false,
      deletDialog: false,
      uploadDialog: false,
      documentsDialog: false,
      documents: false,
      documentsTitleDialog: '',
      printType: 'invoice',
      dialogData: null,
      entrepot: null,
      category: null,
      account: null,
      currencyFilter: null,
      fromAmount: null,
      toAmount: null,
      fromNumber: null,
      toNumber: null,
      fromDate: null,
      toDate: null,
      printId: null,
      showSelect: false,
      filter: false,
      productStatus: null,
      productStatusItems: null,
      model: null,
      from: 1,
      taskDialog: null,
      tag: null,
      temp: null,
      deleteItem: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 0,
      snakbar: false,
      typeForm: null,
      taskId: null,
      snakbarText: null,
      loading: false,
      options: {
        itemsPerPage: 5,
      },
      headers: null,
      type: null,
      search: null,
      selectedHeaders: [],
      headersMap: null,
      pageCount: 1,
      page: 0,
      excelItems: [],
    }),
    computed: {
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
      showHeaders () {
        var app = this
        return this.headers.filter(function (s) {
          if (app.type !== 'sell') {
            if (s.value === 'pre_invoice') {
            } else {
              return app.selectedHeaders.includes(s)
            }
          } else {
            return app.selectedHeaders.includes(s)
          }
        })
      },
      totals: function () {
        // var total = this.items.map(function (value, key) {
        //   app.remove(value, key)
        // })
        var app = this
        app.excelItems = []
        const totals = this.items.reduce((acc, d) => {
          acc.price += (d.price ? parseFloat(d.price.price) + parseFloat((d.discount ? d.discount : 0)) - parseFloat((d.tax ? d.tax : 0)) : 0)
          acc.sumNetAmount += (d.price ? parseFloat(d.price.price) : 0)
          acc.discount += parseFloat(d.discount)
          acc.tax += parseFloat(d.tax)
          return acc
        }, {
          sumNetAmount: 0,
          price: 0,
          discount: 0,
          tax: 0,
        })
        return totals
      },
    },
    watch: {
    },
    activated () {
      this.items = []
      this.page = 0
      this.getItems()
    },
    beforeMount () {
      if (this.$route.name === 'purchaseList') {
        this.type = 'purchase'
      }
      if (this.$route.name === 'presaleList') {
        this.type = 'presale'
      }
      if (this.$route.name === 'mSellList') {
        this.type = 'sell'
      }
      if (this.$route.name === 'returnPurchaseList') {
        this.type = 'returnPurchase'
      }
      if (this.$route.name === 'mReturnSellList') {
        this.type = 'returnSell'
      }
      if (this.$route.name === 'sellTaxPayer') {
        this.type = 'sell'
      }
      if (this.$route.name === 'removedInvoices') {
        this.type = 'removedInvoices'
        this.removedInvoices = 'active'
      }
      if (this.typeProp) {
        this.type = this.typeProp
      }
      this.productStatusItems = [
        {
          value: 'active',
          text: this.$t('active'),
        },
        {
          value: 'deactive',
          text: this.$t('deactive'),
        },
      ]
      if (this.input) {
        this.model = this.input
      }
      this.headersMap = this.headers
      this.selectedHeaders = this.headers
    },
    mounted () {
      this.getItems()
    },
    methods: {
      storeInServer (item) {
        var app = this
        var connection = app.DB
        connection.openDb('db_' + this.$store.state.userId)
        connection.select({
          from: 'invoice',
          where: {
            ouid: item.ouid,
          },
        }).then(function (data) {
          if (data.length > 0 && data[0].store) {
            app.invoiceStore(data[0])
          }
        })
      },
      openUploadDialog (item) {
        this.uploadDialog = true
      },
      openDocumentsDialog (item) {
        this.documentsTitleDialog = this.$t('documents') + ' ' + this.$t(item.type) + ' ' + item.number
        this.documents = item.attachments
        this.documentsDialog = true
      },
      copyInvoice (item) {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'invoice/' + item.uid + '/edit', {
          params: {
            id: item.uid,
          },
        })
          .then(res => {
            res = res.data
            app.$router.push({ name: app.type, params: { itemsProp: res.article } })
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      entrepot_ (item) {
        this.$router.push({ name: item.type + 'Edit', params: { id: item.id } })
      },
      openComponent (component, id) {
        this.dialogData = {
          name: component,
          id: id,
        }
        this.innerComponent = true
      },
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      openTaskDialog (item) {
        this.refId = item.rel_id
        this.taskId = item.id
        this.taskDialog = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      edit (item) {
        if (!this.removedInvoices) {
          this.$router.push({ name: this.type + 'Edit', params: { id: item.uid, tabName: item.number } })
        }
      },
      editCategory (item) {
        if (!this.removedInvoices) {
          this.$router.push({ name: 'invoiceCasherEdit', params: { id: item.uid, tabName: item.number } })
        }
      },
      print (item) {
        if (!this.removedInvoices) {
          this.$router.push({ name: 'invoicePrint', params: { id: item.uid, tabName: item.number } })
        }
      // this.printId = item.uid
      // this.invoicePrintDialog = true
      },
      fishPrint (item) {
        if (!this.removedInvoices) {
          this.$router.push({ name: 'invoiceRollprint', params: { id: item.uid, tabName: item.number } })
        }
      },
      entrepotPrint (item) {
        if (!this.removedInvoices) {
          this.$router.push({ name: item.entrepot.type + 'Print', params: { id: item.entrepot.id } })
        }
      },
      visibilityChanged (e) {
        e && this.getItems()
      },
      getItems () {
        var app = this
        if (app.filter) {
          app.page = 0
          app.items = []
        }
        app.filter = false
        var connection = app.DB
        connection.openDb('db_' + this.$store.state.userId)
        connection.count({
          from: 'invoice',
          where: {
            type: app.type,
            accountId: {
              '-': {
                low: (app.account ? Number(app.account.id) : 0),
                high: (app.account ? Number(app.account.id) : 1000000000000000),
              },
            },
            sumAmount: {
              '-': {
                low: (app.fromAmount ? app.fromAmount : 0),
                high: (app.toAmount ? app.toAmount : 1000000000000000),
              },
            },
            number: {
              '-': {
                low: (app.fromNumber ? Number(app.fromNumber) : 0),
                high: (app.toNumber ? Number(app.toNumber) : 1000000000000000),
              },
            },
            date: {
              '-': {
                low: (app.fromDate ? app.fromDate : 0),
                high: (app.toDate ? app.toDate : 1000000000000000),
              },
            },
          },
        }).then(function (data) {
          app.lastPage = Math.ceil(data / 10)
        }).catch(function (err) {
          alert(err)
        })
        connection.select({
          from: 'invoice',
          where: {
            type: app.type,
            accountId: {
              '-': {
                low: (app.account ? Number(app.account.id) : 0),
                high: (app.account ? Number(app.account.id) : 1000000000000000),
              },
            },
            sumAmount: {
              '-': {
                low: (app.fromAmount ? Number(app.fromAmount) : 0),
                high: (app.toAmount ? Number(app.toAmount) : 1000000000000000),
              },
            },
            number: {
              '-': {
                low: (app.fromNumber ? Number(app.fromNumber) : 0),
                high: (app.toNumber ? Number(app.toNumber) : 1000000000000000),
              },
            },
            date: {
              '-': {
                low: (app.fromDate ? app.fromDate : '1400/01/01'),
                high: (app.toDate ? app.toDate : '1500/12/29'),
              },
            },
          },
        }).then(function (data) {
          if (app.lastPage > app.page) {
            app.page++
          }
          app.items = [
            ...app.items,
            ...data,
          ]
        })
      },
      invoiceSms (item) {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'invoice', {
          params: {
            invoiceSMS: 'active',
            id: item.id,
          },
        })
          .then(res => {
            res = res.data
            app.snakbarColor = 'green'
            app.snakbarText = this.$t('sent')
            app.snakbar = true
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      sendTaxInvoice (type = null) {
        var app = this
        app.loading = true
        var selected = []
        app.selected.map(function (value, key) {
          selected.push(value.id)
        })
        app.$axios.get(this.$endpoint + 'invoice', {
          params: {
            sendTaxInvoice: 'active',
            type: type,
            items: selected,
          },
        })
          .then(res => {
            res = res.data
            if (!type) {
              app.snakbarColor = 'green'
              app.snakbarText = this.$t('sent')
              app.snakbar = true
            } else {
              app.getItems()
            }
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      selectedPrint (item) {
        this.selected = [item]
        this.groupPrintDialog = true
      },
      groupPrintInvoice () {
        var app = this
        app.loading = true
        var selected = []
        app.selected.map(function (value, key) {
          selected.push(value.id)
        })
        app.$axios.get(this.$endpoint + 'invoice', {
          params: {
            groupPrint: 'active',
            items: selected,
          },
        })
          .then(res => {
            res = res.data
            app.$router.push({ name: 'reportViewer', params: { dataProp: res, reportProp: app.printType } })
            app.selected = []
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      remove () {
        var app = this
        if (!app.deleteItem) return false
        app.loading = true
        app.$axios.delete(this.$endpoint + 'invoice/' + this.deleteItem.id)
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.selected = []
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(function () {
            app.deleteItem = null
            app.loading = false
          })
      },
      removegroup () {
        var app = this
        app.loading = true
        var selected = []
        app.selected.map(function (value, key) {
          selected.push({ id: value.id })
        })
        app.$axios.get(this.$endpoint + 'invoice', {
          params: {
            deleteItems: selected,
          },
        })
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.selected = []
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(function () {
            app.deleteItem = null
            app.selected = []
            app.loading = false
          })
      },
    },
  }
</script>

<style scoped>

</style>
